module.exports = __webpack_public_path__ + "static/media/20ECE21.f74502b9.jpg";